import { render, staticRenderFns } from "./SurveysUpdate.vue?vue&type=template&id=831b4080&scoped=true&"
import script from "./SurveysUpdate.vue?vue&type=script&lang=js&"
export * from "./SurveysUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831b4080",
  null
  
)

export default component.exports